import React from "react";
import "../styles/Capability.css";
import { motion } from "framer-motion";

const Capability = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: (i = 0) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.3, duration: 0.6 },
    }),
  };

  return (
    <>
      <motion.div
        className="title-capability"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeUp}
        custom={2}
      >
        <h2
          style={{
            fontSize: '35px',
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          Capability Statements
        </h2>
      </motion.div>

      <div className="capability-wrapper">
        {/* <motion.div
          className="capability-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <h2 className="cap-title">Executive Summary</h2>
          <p>
            Under Kevin’s leadership and the addition of{" "}
            <strong>Gretchen Thomas</strong> in 2019 as Vice President, TMC's
            foundation strengthened with administrative and procurement
            excellence.
          </p>
          <p>
            Gretchen brings extensive knowledge in purchasing, accounting, and
            organizational leadership — fueling our continued growth in a
            competitive industry.
          </p>
          <p>
            We handle{" "}
            <strong>ground-up construction, interior build-outs</strong>, and
            specialized subcontracting while self-performing critical trades
            like plumbing and carpentry — enabling high control over quality and
            safety.
          </p>
          <p>
            Backed by <em>Contractor Foreman</em> project management and a
            skilled in-house team, TMC delivers seamless, efficient, and
            client-focused construction experiences.
          </p>
        </motion.div>

        <motion.div
          className="capability-card"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="cap-title">Company Profile & Capabilities</h2>
          <p>
            <strong>TMC Contractors</strong> is a general contracting and
            self-perform carpentry, plumbing, and painting firm known for
            delivering high-quality construction services across government,
            state sectors, residential, commercial, and educational domains.
          </p>
          <p>
            Founded by <strong>Kevin Thomas</strong>, a seasoned veteran with
            over 30 years of industry experience— TMC Contractors is recognized
            for timely delivery, quality craftsmanship, and exceptional client
            service.
          </p>
          <p>
            From his early days at <em>Turner Construction</em> to leading
            multi-million-dollar projects, TMC has grown into a powerhouse with
            a bonding capacity of <strong>$2.5M</strong> (single) and{" "}
            <strong>$6M</strong> (aggregate).
          </p>
        </motion.div> */}

        {/* === IMAGE PREVIEW === */}
        <motion.div
          className="image-preview"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          style={{ marginBottom: "20px", width: "75%", textAlign: "center" }}
        >
          {/* <h3 style={{ marginBottom: "10px" }}>Capability Image Preview</h3> */}
          <img
            src="/files/Cap_ Statement.jpg"
            alt="Capability Statement Preview"
            style={{
              maxWidth: "100%",
              height: "auto",
              border: "1px solid #ccc",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          />
        </motion.div>

        {/* === DOWNLOAD BUTTON === */}
        <motion.div
          className="download-button"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        >
          <a href="/files/Capabality_Statement.pdf" download>
            Download
          </a>
        </motion.div>
      </div>
    </>
  );
};

export default Capability;
